import { deleteOperationsGroup } from "actions/Utilities/OperationsGroup";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";
import { useRecoilState } from "recoil";
import { operationsGroupReFetching } from "../atoms/atoms";

export default function useDeleteOperationsGroup() {
  const [isReFetching, setIsReFetching] = useRecoilState(
    operationsGroupReFetching
  );
  const { mutate } = useMutation(
    (ids: number[]) => deleteOperationsGroup(ids),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire(
            "Disabling Operations Group failed",
            res.Message,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Operations Group Disabled Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Operations Group Disabled Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Disabling Operations Group failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "Operations Group not found":
              toast.fire(
                "Disabling Operations Group failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Disabling Operations Group failed", res, "error");
          }
        }
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error) => {
        toast.fire(
          "Disabling Operations Group failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );

  return mutate;
}
